import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class JEService extends BaseService {

  private rdServiceUrl = 'https://localhost:11200';

  constructor(private http: HttpClient, tokenService: TokenService, private router: Router) {
    super(tokenService);
  }
  // GET SERVICES
  getFarmerPondVerification(userId: any, stage: any) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForPondVerification?UserId=${userId}&Stage=${stage}`, { headers: this.buildHeaders() });
  }

  // getFarmerApplicationForPondVerStage1(userId:any)
  // {
  //   return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForPondVerificationStage1?UserId=${userId}`, { headers: this.buildHeaders() });
  // }

  getFarmerApplicationForPondVerStage1(userId: any, AppType: any, financialYear: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')  || (this.router.url.split('/')[1] == 'ew-je') || (this.router.url.split('/')[1] == 'ew-department')) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerAppForPondVer_SubsidyCalc_Stage1?UserId=${userId}&AppType=${AppType}&financialyear=${financialYear}`, { headers: this.buildHeaders() });
    }
    else{
      return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForPondVerificationStage1?UserId=${userId}&AppType=${AppType}&financialyear=${financialYear}`, { headers: this.buildHeaders() });
    }
  }

  // getFarmerApplicationForPondVerStage2(userId:any)
  // {
  //   return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForPondVerificationStage2?UserId=${userId}`, { headers: this.buildHeaders() });

  // }

  getFarmerApplicationForPondVerStage2(userId: any, AppType: any, financialYear: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin') || (this.router.url.split('/')[1] == 'ew-je') || (this.router.url.split('/')[1] == 'ew-department')) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerAppForPondVer_SubsidyCalc_Stage2?UserId=${userId}&AppType=${AppType}&financialyear=${financialYear}`, { headers: this.buildHeaders() });
    }
    else{
      return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForPondVerificationStage2?UserId=${userId}&AppType=${AppType}&financialyear=${financialYear}`, { headers: this.buildHeaders() });
    }
  }

  GetFarmerAppForPondVer_SubsidyCalc_Stage3(userId: any, AppType: any, financialYear: any) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerAppForPondVer_SubsidyCalc_Stage3?UserId=${userId}&AppType=${AppType}&financialyear=${financialYear}`, { headers: this.buildHeaders() });

  }

  // getPondVerDataByAppIdStage1(appId:any){
  //   return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerificationDataByAppIdStage1?AppId=${appId}`, { headers: this.buildHeaders() });
  // }

  getPondVerDataByAppIdStage1(appId: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')  || (this.router.url.split('/')[1] == 'ew-je') || (this.router.url.split('/')[1] == 'ew-department')) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerDataByAppId_SubsidyCalc_Stage1?AppId=${appId}`, { headers: this.buildHeaders() });
  }
  else{
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerificationDataByAppIdStage1?AppId=${appId}`, { headers: this.buildHeaders() });
  }
}

  // getPondVerDataByAppIdStage2(appId:any){
  //   return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerificationDataByAppIdStage2?AppId=${appId}`, { headers: this.buildHeaders() });
  // }

  getPondVerDataByAppIdStage2(appId: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')  || (this.router.url.split('/')[1] == 'ew-je') || (this.router.url.split('/')[1] == 'ew-department')) {
      return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerDataByAppId_SubsidyCalc_Stage2?AppId=${appId}`, { headers: this.buildHeaders() });
    }
    else{
      return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerificationDataByAppIdStage2?AppId=${appId}`, { headers: this.buildHeaders() });
    }
   
   
  }

  getPondVerDataByAppId_SubsidyCalc_Stage3(appId: any) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerDataByAppId_SubsidyCalc_Stage3?AppId=${appId}`, { headers: this.buildHeaders() });
  }

  getSubsidyDetails(appId: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetSubsidyDetails?AppId=${appId}`, { headers: this.buildHeaders() });
  }
  //POST SERVICES
  vendorPondEstimate(vendorPondEstimate: any) {
    return this.http.post(`${environment.apiUrl}Vendor/UpsertPondEstimate`, vendorPondEstimate, { headers: this.buildHeaders() });
  }

  // pondSurveyStage1(pondSurveyStage1: any){
  //   return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurveyStage1`, pondSurveyStage1, { headers: this.buildHeaders() });
  // }

  pondSurveyStage1(pondSurveyStage1: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin') || (this.router.url.split('/')[1] == 'ew-je') || (this.router.url.split('/')[1] == 'ew-department')) {
    return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurvey_SubsidyCalc_Stage1`, pondSurveyStage1, { headers: this.buildHeaders() });
  }
  else{
    return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurveyStage1`, pondSurveyStage1, { headers: this.buildHeaders() });
  }
}

  // pondSurveyStage2(pondSurveyStage2: any){
  //   return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurveyStage2`, pondSurveyStage2, { headers: this.buildHeaders() });
  // }

  pondSurveyStage2(pondSurveyStage2: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin') || (this.router.url.split('/')[1] == 'ew-je') || (this.router.url.split('/')[1] == 'ew-department')) {
    return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurvey_SubsidyCalc_Stage2`, pondSurveyStage2, { headers: this.buildHeaders() });
  }
  else{
    return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurveyStage2`, pondSurveyStage2, { headers: this.buildHeaders() });
  }
}

  //POST SERVICES
  PondFalseIntimation(PondFalseIntimation: any) {
    return this.http.post(`${environment.apiUrl}Vendor/InsertPondFalseIntimation`, PondFalseIntimation, { headers: this.buildHeaders() });
  }

  //GET Physical Verification Applications for MI
  getApplicationsForPhysicalVerification(userId, appType, financialYear) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin') || (this.router.url.split('/')[1] == 'ew-je') || (this.router.url.split('/')[1] == 'ew-department')) {
      return this.http.get(`${environment.apiUrl}DashBoard/GetApplicationsForMIPhysicalVer_SubsidyCalc?UserId=${userId}&AppType=${appType}&financialYear=${financialYear}`, { headers: this.buildHeaders() });
    } else {
      return this.http.get(`${environment.apiUrl}DashBoard/GetApplicationsForPhysicalVerification?UserId=${userId}&AppType=${appType}&financialYear=${financialYear}`, { headers: this.buildHeaders() });
    }
  }

  //GET Application data for physical verification
  getApplicationDataForPhysicalVerification(autoId, userId) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')  || (this.router.url.split('/')[1] == 'ew-je') || (this.router.url.split('/')[1] == 'ew-department')) {
      return this.http.get(`${environment.apiUrl}DashBoard/GetApplicationDataForMIPhysicalVer_SubsidyCalc?AutoId=${autoId}&UserId=${userId}`, { headers: this.buildHeaders() });
    } else {
      return this.http.get(`${environment.apiUrl}DashBoard/GetApplicationDataForPhysicalVer?AutoId=${autoId}&UserId=${userId}`, { headers: this.buildHeaders() });
    }
  }

  getApplicationDataForPhysicalVerification_CalculatedSubsidy(autoId, userId) {
    return this.http.get(`${environment.apiUrl}DashBoard/GetApplicationDataForPhysicalVer?AutoId=${autoId}&UserId=${userId}`, { headers: this.buildHeaders() });
  }


  //POST Application data for physical verification
  insertPhysicalVerification(reqBody: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')  || (this.router.url.split('/')[1] == 'ew-je') || (this.router.url.split('/')[1] == 'ew-department')) {
      return this.http.post(`${environment.apiUrl}DashBoard/InsertPhysicalMIVerification_SubsidyCalc`, reqBody, { headers: this.buildHeaders() });
    } else {
      return this.http.post(`${environment.apiUrl}DashBoard/InsertPhysicalVerification`, reqBody, { headers: this.buildHeaders() });
    }
  }

  insertPondSurvey_SubsidyCalc_Stage3(reqBody: any) {
    return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurvey_SubsidyCalc_Stage3`, reqBody, { headers: this.buildHeaders() });
  }

  //Insert Servey Attachments
  insertServayAttachments(reqBody: any) {
    return this.http.post(`${environment.apiUrl}Department/InsertServayAttachments`, reqBody, { headers: this.buildHeaders() });
  }
  GetSubsidyAppForPondVer_SubsidyCalc_Stage1(userId: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondStage1SubsidyToFarmerLot?UserId=${userId}`, { headers: this.buildHeaders() });
  
  }
  GetSubsidyAppForPondVer_SubsidyCalc_Stage2(userId: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondStage2SubsidyToFarmerLot?UserId=${userId}`, { headers: this.buildHeaders() });

  }
  GetSubsidyAppForPondVer_SubsidyCalc_Stage3(userId: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondStage3SubsidyToFarmerLot?UserId=${userId}`);

  }

  getMICADA1data(userId) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetMISurveyCoordinates?UserId=${userId}`, { headers: this.buildHeaders() })
  }
  getVendorGridData(userId){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetAllVendorRegnDetailsForGrid?UserId=${userId}`, { headers: this.buildHeaders() })

  }
  
  getVendorFullDetailsByEmail(emailId){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetVendorFullDetailsByEmail?email=${emailId}`, { headers: this.buildHeaders() })
  }

  submitVendorApprovalStatus(reqBody){
    return this.http.post(`${environment.apiUrl}Vendor/SubmitVendorApprovalStatus`, reqBody, { headers: this.buildHeaders() });
  }

  insertMISurveyCoordinates(reqBody){
    return this.http.post(`${environment.apiUrl}Department/InsertMISurveyCoordinates`, reqBody, { headers: this.buildHeaders() });
  }

  validateAadharBiometric(reqBody){
    const headers = new HttpHeaders({
      'Content-Type': 'text/xml', // or 'application/xml'
    });

    return this.http.post(`${environment.apiUrl}External/ValidateAadharBiometric`, reqBody, {
      headers: headers,
      responseType: 'text'
    });

    // return this.http.post(`${environment.apiUrl}External/ValidateAadharBiometric`, reqBody, {responseType: 'text'});
  }

  // rdservice(){
  //   return this.http.post(`https://LocalHost:11200`, {responseType: 'text'});
  // }

  rdservice(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Add any other required headers
    });

    // Creating a request with timestamp parameter
    const url = `${this.rdServiceUrl}/?ts=${new Date().getTime()}`;

    // Making the HTTP request
    return this.http.request('RDSERVICE', url, { headers });
  }

  deviceInfo(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Add any other required headers
    });

    // Creating a request with timestamp parameter
    const url = `${this.rdServiceUrl}/rd/info/?ts=${new Date().getTime()}`;

    // Making the HTTP request
    return this.http.request('DEVICEINFO', url, { headers });
  }

  capture(): Observable<any> {
    const headers = new HttpHeaders({
      // 'Content-Type': 'application/json',
      'Content-Type': 'text/xml',
      // Add any other required headers
    });

    // Creating a request with timestamp parameter
    const url = `${this.rdServiceUrl}/rd/capture/?ts=${new Date().getTime()}`;


    const xmlBody = 
    // `<PidOptions> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="20000" otp="" posh="UNKNOWN" wadh="" env="P"/> <Demo></Demo><CustOpts> <Param name="test2" value="KU" /></CustOpts> </PidOptions>`;
    "<PidOptions> <Opts fCount=\"1\" fType=\"2\" iCount=\"0\" pCount=\"0\" format=\"0\" pidVer=\"2.0\" timeout=\"20000\" otp=\"\" posh=\"UNKNOWN\" wadh=\"" + '' + "\" env=\""+ 'PP' +"\"/> <Demo></Demo><CustOpts> <Param name=\"test2\" value=\"KU\" /></CustOpts> </PidOptions>"
    // Making the HTTP request
    return this.http.request('CAPTURE', url, {
      headers,
      body: xmlBody
    });
  }


}
